module.exports = __webpack_public_path__ + "img/logo_gtc.ca00bdc2.webp";